module.exports = __webpack_public_path__ + "static/media/sorting-arrow-up.31349a42.svg";